import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import { fetchArticleCategories, fetchArticles } from "../../../api/articles";
import { maxSymbolEllipsis } from "../../../helpers/functions";

const ClockIcon = () => (
    <svg className="w-3.5 h-3.5 mr-1 text-slate-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
);

const ArticleListPage = () => {
    const [articles, setArticles] = useState();
    const [categories, setCategories] = useState();

    const fetchArticle = async () => {
        const _articles = await fetchArticles({ 'sub': true });
        if (_articles != null) {
            setArticles(_articles);
        }
    }

    const fetchCategories = async () => {
        const fetchCategory = await fetchArticleCategories();
        if (fetchCategory != null) {
            setCategories(fetchCategory);
        }
    }

    useEffect(() => {
        fetchArticle();
        fetchCategories();
    }, []);

    return (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
            {/* Header */}
            <div className="mb-8 space-y-4">
                <h1 className="text-2xl font-bold text-slate-800 tracking-tight">
                    Статьи и новости
                </h1>

                {/* Categories */}
                <div className="space-y-3">
                    <div className="overflow-x-auto pb-2">
                        <nav className="flex space-x-3 min-w-max">
                            <Link
                                to="/articles"
                                className="px-4 py-1.5 text-sm font-semibold bg-blue-600 text-white rounded-full transition-colors"
                            >
                                Все категории
                            </Link>
                            {categories?.map((category) => (
                                <Link
                                    key={category.id}
                                    to={`/articles_categories/${category.id}`}
                                    className="px-4 py-1.5 text-sm font-semibold bg-slate-50 text-slate-600 rounded-full hover:bg-blue-50 hover:text-blue-600 border border-slate-100 hover:border-blue-100 transition-colors"
                                >
                                    {category.name}
                                </Link>
                            ))}
                        </nav>
                    </div>
                </div>
            </div>

            {/* Articles Grid */}
            {articles ? (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                    {articles.map((article) => (
                        <Link 
                            key={article.id}
                            to={`/article/${article.id}`}
                            className="group no-underline block h-full"
                        >
                            <article className="bg-white rounded-2xl border border-slate-100 hover:border-blue-100 shadow-sm hover:shadow-lg hover:-translate-y-1 transition-all duration-300 overflow-hidden h-full flex flex-col">
                                {/* Image */}
                                <div className="w-full h-[170px] overflow-hidden bg-slate-50 relative">
                                    <img
                                        src={article.image}
                                        alt={article.title}
                                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                                    />
                                </div>

                                {/* Content */}
                                <div className="flex flex-col flex-grow p-4 space-y-3">
                                    <h3 className="text-slate-800 font-semibold text-[15px] group-hover:text-blue-600 transition-colors line-clamp-2">
                                        {article.title}
                                    </h3>
                                    
                                    <div
                                        className="text-slate-500 text-xs leading-relaxed line-clamp-3"
                                        dangerouslySetInnerHTML={{
                                            __html: maxSymbolEllipsis(article.text, 80)
                                        }}
                                    />

                                    <div className="flex items-center text-slate-400 text-[11px] mt-auto pt-3 border-t border-slate-50">
                                        <ClockIcon />
                                        <span>{moment(article.created_at, 'YYYYMMDD, H:mm:ss').fromNow()}</span>
                                    </div>
                                </div>
                            </article>
                        </Link>
                    ))}
                </div>
            ) : (
                <div className="flex justify-center items-center py-12">
                    <div className="text-slate-500 text-sm">
                        Загрузка статей...
                    </div>
                </div>
            )}
        </div>
    );
}

export default ArticleListPage;